import { useTheme } from '@quality24/design-system';
import { useTranslation } from 'react-i18next';
import { Theme } from '@/inpatient-patient-pwa/types/theme';
import useI18nResolvers from '@/inpatient-patient-pwa/i18n/useI18nResolvers';

/**
 * Hospital-specific labels from `theme.texts`, resolved for the current
 * language. `texts.*I18N` locale maps take precedence over the untranslated
 * `texts.*` siblings, and both fall back to the app's own translations when the
 * hospital has not customized the label.
 */
const useCustomData = () => {
  const { theme } = useTheme<Theme>();
  const { t } = useTranslation();
  const { resolveI18n } = useI18nResolvers();

  return {
    generalInfo:
      resolveI18n(theme?.texts?.generalInfoI18N) ||
      theme?.texts?.generalInfo ||
      t('customData.generalInfo'),
    infrastructureCalls:
      resolveI18n(theme?.texts?.infrastructureCallsI18N) ||
      theme?.texts?.infrastructureCalls ||
      t('customData.otherServices'),
  };
};

export default useCustomData;
